module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_yokohama-74ac2e9701187485d14737dc31fd46a3.jpg";